import styled, { keyframes } from "styled-components";

const change = keyframes`
    0% {
        background-position: -100% 0;
    }
  
    100% {
        background-position: 100% 0;
    }
`;

export const ShimmerEffect = styled.div`
	display: block;
	width: ${(props) => props.width}px;
	height: ${(props) => props.height}px;
	background: #f6f7f8;
	background-image: linear-gradient(
		to right,
		#f6f7f8 0%,
		#dddfe2 20%,
		#f6f7f8 40%,
		#f6f7f8 100%
	);
	background-repeat: no-repeat;
	background-size: 800px 100%;
	border-radius: ${(props) => props.border}px;
	animation: ${change} 1s ease-in-out infinite;
`;
